<template>
  <font-awesome-layers>
    <font-awesome-icon :icon="faCircle" transform="shrink-14 up-5 left-5" />
    <font-awesome-icon :icon="faCircle" transform="shrink-14 up-5" />
    <font-awesome-icon :icon="faCircle" transform="shrink-14 up-5 right-5" />
    <font-awesome-icon :icon="faCircle" transform="shrink-14 up-1 left-5" />
    <font-awesome-icon :icon="faCircle" transform="shrink-14 up-1" />
    <font-awesome-icon :icon="faCircle" transform="shrink-14 up-1 right-5" />
    <font-awesome-icon :icon="faCircle" transform="shrink-14 down-3 left-5" />
    <font-awesome-icon :icon="faCircle" transform="shrink-14 down-3" />
    <font-awesome-icon :icon="faCircle" transform="shrink-14 down-3 right-5" />
    <font-awesome-icon :icon="faCircle" transform="shrink-14 down-7" />
  </font-awesome-layers>
</template>

<script>
import { FontAwesomeLayers, FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle'

export default {
  components: {
    FontAwesomeLayers,
    FontAwesomeIcon
  },
  data () {
    return {
      faCircle
    }
  }
}
</script>



// WEBPACK FOOTER //
// DialpadIcon.vue?20f1c0c4